import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApContentService, ApContentPipe } from '@ap/content';
import { ModalContent } from '@ap/modal';
import { ApButtonComponent } from '@ap/button';

import { ApKeepAliveService } from '../keep-alive.service';

import content from './keep-alive-modal.content.json';

/**
 * @ngdoc component
 * @name ApKeepAliveModalComponent
 */
@Component({
    selector: 'ap-keep-alive-modal',
    templateUrl: './keep-alive-modal.component.html',
    styleUrls: ['./keep-alive-modal.component.scss'],
    imports: [ApButtonComponent, ApContentPipe]
})
export class ApKeepAliveModalComponent extends ModalContent<any> implements OnInit, OnDestroy {
    private readonly contentService = inject(ApContentService);
    private readonly keepAliveService = inject(ApKeepAliveService);

    public timeLeft: number;
    private timeLeftSubscription: Subscription;

    public ngOnInit(): void {
        this.timeLeftSubscription = this.keepAliveService.timeLeft$.subscribe((timeLeft) => (this.timeLeft = Math.round(timeLeft / 1000)));
        this.contentService.addContentItems(content);
    }

    public ngOnDestroy(): void {
        this.timeLeftSubscription.unsubscribe();
    }
}
